import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { searchQuoteRequestLineSimilarPartsQuery } from "#modules/similarPart/infra/searchQuoteRequestLineSimilarParts.query";
import { FilterQuery } from "shared";

import { PAGE_SIZE } from "../view/SearchResult";

type Options = {
  enabled?: boolean;
};

export const useSearchQuoteRequestLineSimilarParts = (
  {
    filtersParams,
    id,
    limit,
  }: { id: string | undefined; filtersParams: FilterQuery; limit?: number },
  options: Options = { enabled: true },
) => {
  const { data, ...rest } = useQuery({
    ...searchQuoteRequestLineSimilarPartsQuery(id, filtersParams, limit),
    placeholderData: limit && limit > PAGE_SIZE ? keepPreviousData : undefined,
    enabled: options.enabled && !!id,
  });

  return { similarParts: data, ...rest };
};
